import { defineMessages } from 'react-intl';

const globalSearchTranslations = defineMessages({
    ng_globalSearch_recentSearches: {
        id: 'ng_globalSearch_recentSearches',
        defaultMessage: 'Recent Searches'
    },
    ng_globalSearch_clearRecent: {
        id: 'ng_globalSearch_clearRecent',
        defaultMessage: 'Clear Recent'
    },
    ng_globalSearch_alsoShowingResultsFor: {
        id: 'ng_globalSearch_alsoShowingResultsFor',
        defaultMessage: 'Also showing results for'
    },
    ng_globalSearch_showing: {
        id: 'ng_globalSearch_showing',
        defaultMessage: 'Showing'
    },
    ng_globalSearch_result: {
        id: 'ng_globalSearch_result',
        defaultMessage: 'Result'
    },
    ng_globalSearch_results: {
        id: 'ng_globalSearch_results',
        defaultMessage: 'Results'
    },
    ng_globalSearch_searchPage: {
        id: 'ng_globalSearch_searchPage',
        defaultMessage: 'Search page...'
    },
    ng_globalSearch_toNavigate: {
        id: 'ng_globalSearch_toNavigate',
        defaultMessage: 'to navigate'
    },
    ng_globalSearch_toSelect: {
        id: 'ng_globalSearch_toSelect',
        defaultMessage: 'to select'
    },
    ng_globalSearch_toDismiss: {
        id: 'ng_globalSearch_toDismiss',
        defaultMessage: 'to dismiss'
    },
    ng_globalSearch_profile: {
        id: 'ui.menu.tab.profile',
        defaultMessage: 'Profile'
    },
    ng_globalSearch_sendMessage: {
        id: 'ng_globalSearch_sendMessage',
        defaultMessage: 'Send Message'
    },
    ng_globalSearch_notifications: {
        id: 'ui.menu.tab.notification',
        defaultMessage: 'Notifications'
    },
    ng_globalSearch_addNewNotification: {
        id: 'submenu-notifications-add-new-notification',
        defaultMessage: 'Add New Notification'
    },
    ng_globalSearch_addNewNotificationGroup: {
        id: 'submenu-notifications-add-new-notification-group',
        defaultMessage: 'Add New Notification Group'
    },
    ng_globalSearch_executeScenario: {
        id: 'ng_globalSearch_executeScenario',
        defaultMessage: 'Execute Scenario'
    },
    ng_globalSearch_scenarioLibrary: {
        id: 'ng_globalSearch_scenarioLibrary',
        defaultMessage: 'Scenario Library'
    },
    ng_globalSearch_savedScenarios: {
        id: 'ng_globalSearch_savedScenarios',
        defaultMessage: 'Saved Scenarios'
    },
    ng_globalSearch_fileBasedMessage: {
        id: 'ng_globalSearch_fileBasedMessage',
        defaultMessage: 'File-Based Message'
    },
    ng_globalSearch_fileBasedMessaging: {
        id: 'ng_globalSearch_fileBasedMessaging',
        defaultMessage: 'File-Based Messaging'
    },
    ng_globalSearch_recipient: {
        id: 'search.field.recipient',
        defaultMessage: 'Recipient'
    },
    ng_globalSearch_manageContacts: {
        id: 'ng_globalSearch_manageContacts',
        defaultMessage: 'Manage Contacts'
    },
    ng_globalSearch_addContact: {
        id: 'ng_globalSearch_addContact',
        defaultMessage: 'Add Contact'
    },
    ng_globalSearch_users: {
        id: 'ng_permissionsUsers',
        defaultMessage: 'Users'
    },
    ng_globalSearch_addNewUser: {
        id: 'submenu-users-add-new-user',
        defaultMessage: 'Add New User'
    },
    ng_globalSearch_data: {
        id: 'ng_globalSearch_data',
        defaultMessage: 'Data'
    },
    ng_globalSearch_import: {
        id: 'ng_globalSearch_import',
        defaultMessage: 'Import'
    },
    ng_globalSearch_importWizard: {
        id: 'ng_globalSearch_importWizard',
        defaultMessage: 'Import Wizard'
    },
    ng_globalSearch_importUsers: {
        id: 'submenu-users-import-users',
        defaultMessage: 'Import Users'
    },
    ng_globalSearch_contactsLoader: {
        id: 'ng_globalSearch_contactsLoader',
        defaultMessage: 'Contacts Loader'
    },
    ng_globalSearch_notificationReports: {
        id: 'menu-notifications-reports',
        defaultMessage: 'Notification Reports'
    },
    ng_globalSearch_messageHistory: {
        id: 'ng_globalSearch_messageHistory',
        defaultMessage: 'Message History'
    },
    ng_globalSearch_callBridge: {
        id: 'ui.page.notification.compose.section.messageAndResponseOptions.action.callBridge',
        defaultMessage: 'Call Bridge'
    },
    ng_globalSearch_callBridging: {
        id: 'ng_globalSearch_callBridging',
        defaultMessage: 'Call Bridging'
    },
    ng_globalSearch_weatherblast: {
        id: 'ng_globalSearch_weatherblast',
        defaultMessage: 'Weatherblast'
    },
    ng_globalSearch_location: {
        id: 'ng_globalSearch_location',
        defaultMessage: 'Location'
    },
    ng_globalSearch_direct: {
        id: 'ng_globalSearch_direct',
        defaultMessage: 'Direct'
    },
    ng_globalSearch_folders: {
        id: 'ng_Folders',
        defaultMessage: 'Folders'
    },
    ng_globalSearch_smsOptIn: {
        id: 'ng_globalSearch_smsOptIn',
        defaultMessage: 'SMS Opt-In'
    },
    ng_globalSearch_permissions: {
        id: 'search.field.permission',
        defaultMessage: 'Permissions'
    },
    ng_globalSearch_subaccount: {
        id: 'ng_globalSearch_subaccount',
        defaultMessage: 'Subaccount'
    },
    ng_globalSearch_switchAccount: {
        id: 'ng_globalSearch_switchAccount',
        defaultMessage: 'Switch Account'
    },
    ng_globalSearch_initiator: {
        id: 'search.field.permission.initiator.displayName',
        defaultMessage: 'Initiator'
    },
    ng_globalSearch_sender: {
        id: 'ng_globalSearch_sender',
        defaultMessage: 'Sender'
    },
    ng_globalSearch_messenger: {
        id: 'ng_globalSearch_messenger',
        defaultMessage: 'Messenger'
    },
    ng_globalSearch_device: {
        id: 'ng_globalSearch_device',
        defaultMessage: 'Device'
    },
    ng_globalSearch_deviceTypes: {
        id: 'ng_globalSearch_deviceTypes',
        defaultMessage: 'Device Types'
    },
    ng_globalSearch_customFields: {
        id: 'ng_globalSearch_customFields',
        defaultMessage: 'Custom Fields'
    },
    ng_globalSearch_customLabels: {
        id: 'ng_core_customLabels',
        defaultMessage: 'Custom Labels'
    },
    ng_globalSearch_deviceLabels: {
        id: 'ng_globalSearch_deviceLabels',
        defaultMessage: 'Device Labels'
    },
    ng_globalSearch_alertTemplates: {
        id: 'ng_globalSearch_alertTemplates',
        defaultMessage: 'Alert Templates'
    },
    ng_globalSearch_messageTemplates: {
        id: 'ng_globalSearch_messageTemplates',
        defaultMessage: 'Message Templates'
    },
    ng_globalSearch_customReports: {
        id: 'menu-notifications-custom-reports',
        defaultMessage: 'Custom Reports'
    },
    ng_globalSearch_recipientMessageBoards: {
        id: 'ng_globalSearch_recipientMessageBoards',
        defaultMessage: 'Recipient Message Boards'
    },
    ng_globalSearch_bulletin: {
        id: 'ng_globalSearch_bulletin',
        defaultMessage: 'Bulletin'
    },
    ng_globalSearch_bulletinBoards: {
        id: 'ng_globalSearch_bulletinBoards',
        defaultMessage: 'Bulletin Boards'
    },
    ng_globalSearch_gdpr: {
        id: 'ng_globalSearch_gdpr',
        defaultMessage: 'GDPR'
    },
    ng_globalSearch_rightToBeForgotten: {
        id: 'ng_globalSearch_rightToBeForgotten',
        defaultMessage: 'Right To Be Forgotten'
    },
    ng_globalSearch_rtbfSubmission: {
        id: 'submenu-administration-rtbf-submission',
        defaultMessage: 'RTBF Submission'
    },
    ng_globalSearch_myAccountInbox: {
        id: 'ng_globalSearch_myAccountInbox',
        defaultMessage: 'My Account Inbox'
    },
    ng_globalSearch_auditLogs: {
        id: 'ng_globalSearch_auditLogs',
        defaultMessage: 'Audit Logs'
    },
    ng_globalSearch_desktopAgent: {
        id: 'ng_globalSearch_desktopAgent',
        defaultMessage: 'Desktop Agent'
    },
    ng_globalSearch_desktopAgentV2: {
        id: 'ng_globalSearch_desktopAgentV2',
        defaultMessage: 'Desktop Agent V2'
    },
    ng_globalSearch_exportUsageDetails: {
        id: 'submenu-administration-export-usage-details',
        defaultMessage: 'Export Usage Details'
    },
    ng_globalSearch_notificationGroups: {
        id: 'menu-notifications-groups',
        defaultMessage: 'Notification Groups'
    },
    ng_globalSearch_divisions: {
        id: 'ui.page.notification.compose.section.details.divisionLabel',
        defaultMessage: 'Divisions'
    },
    ng_globalSearch_accountability: {
        id: 'ng_globalSearch_accountability',
        defaultMessage: 'Accountability'
    }
});

export default globalSearchTranslations;
